<template>
  <div>
    <Timepicker :appointment="appointment" @saved="onSave" />
  </div>
</template>

<script setup lang="ts">
import Timepicker from "@/components/Seranova/Timepicker/Timepicker.vue";
import { AppointmentV2 } from "@/typings/appointment";
const emit = defineEmits(["saved"]);
defineProps<{ appointment: AppointmentV2 }>();
const onSave = () => {
  emit("saved");
  tippy.hideAll();
};
</script>

<style scoped></style>
